import MuiMenuItem, { MenuItemProps } from '@mui/material/MenuItem'
import { Link } from '../Link'

export default function MenuItem(props: MenuItemProps & { href?: string }) {
    return <MuiMenuItem {...props} {...{ component: Link as any }} />
}
